module.exports = __webpack_public_path__ + "static/img/pro01.75639dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/pro01.jpg
// module id = GC50
// module chunks = 1